import {BillingLayout} from "./pages/admin/billing/layout";
import {Route} from "react-router-dom";
import {AdminBillingPage} from "./pages/admin/billing";
import {BillListPage} from "./pages/admin/billing/bill";
import {BillBatchPage} from "./pages/admin/billing/bill/batch";
import {BillEditPage} from "./pages/admin/billing/bill/form";
import {CustomerListPage} from "./pages/admin/billing/customer";
import {CustomerEditPage} from "./pages/admin/billing/customer/form";
import {OccupationPage} from "./pages/admin/billing/occupation";
import {WikiPageListPage} from "./pages/admin/employee/wiki";
import {SECTION_BILLING, WikiPageEditPage} from "./pages/admin/employee/wiki/form";
import * as React from "react";
import SideBarItem from "./sidebar_item";
import {AccountBalance, Dashboard, East, Euro, GridOn, ImportExport, NoteAlt, People, Receipt, Savings, Timer} from "@mui/icons-material";
import {SepaMandateListPage} from "./pages/admin/billing/sepa-mandate";
import {SepaMandateEditPage} from "./pages/admin/billing/sepa-mandate/form";
import {SepaRemittanceListPage} from "./pages/admin/billing/sepa-remittance";
import {SepaRemittanceDetailPage} from "./pages/admin/billing/sepa-remittance/detail";
import {BillDiscountListPage} from "./pages/admin/billing/discount";
import {BillDiscountEditPage} from "./pages/admin/billing/discount/form";
import {DedicationBatchPage} from "./pages/admin/billing/occupation/dedication/dedication_batch";
import {BudgetEditPage} from "./pages/admin/billing/budget/form";
import {BudgetListPage} from "./pages/admin/billing/budget";
import {BudgetPaymentEditPage} from "./pages/admin/billing/budget-payment/form";
import {OverviewPage} from "./pages/admin/billing/overview";
import {SupportSlaPage} from "./pages/admin/billing/support-sla";
import {RedmineImportPage} from "./pages/admin/billing/occupation/dedication/dedication_import";


const AdminBillingRoutes = () => {
	return (
		<Route path="/app/admin/billing" element={<BillingLayout/>}>
			<Route index element={<AdminBillingPage/>}/>

			<Route path="/app/admin/billing/overview" element={<OverviewPage/>}/>

			<Route path="/app/admin/billing/bill" element={<BillListPage/>}/>
			<Route path="/app/admin/billing/bill-batch" element={<BillBatchPage/>}/>
			<Route path="/app/admin/billing/bill/:id" element={<BillEditPage/>}/>
			<Route path="/app/admin/billing/bill/new" element={<BillEditPage/>}/>

			<Route path="/app/admin/billing/discount" element={<BillDiscountListPage/>}/>
			<Route path="/app/admin/billing/discount/:id" element={<BillDiscountEditPage/>}/>
			<Route path="/app/admin/billing/discount/new" element={<BillDiscountEditPage/>}/>

			<Route path="/app/admin/billing/budget" element={<BudgetListPage/>}/>
			<Route path="/app/admin/billing/support-sla" element={<SupportSlaPage/>}/>
			<Route path="/app/admin/billing/budget/:id" element={<BudgetEditPage/>}/>
			<Route path="/app/admin/billing/budget/new" element={<BudgetEditPage/>}/>

			<Route path="/app/admin/billing/budget-payment/:id" element={<BudgetPaymentEditPage/>}/>
			<Route path="/app/admin/billing/budget-payment/new" element={<BudgetPaymentEditPage/>}/>

			<Route path="/app/admin/billing/sepa-mandate" element={<SepaMandateListPage/>}/>
			<Route path="/app/admin/billing/sepa-mandate/:id" element={<SepaMandateEditPage/>}/>
			<Route path="/app/admin/billing/sepa-mandate/new" element={<SepaMandateEditPage/>}/>

			<Route path="/app/admin/billing/sepa-remittance" element={<SepaRemittanceListPage/>}/>
			<Route path="/app/admin/billing/sepa-remittance/:id" element={<SepaRemittanceDetailPage/>}/>

			<Route path="/app/admin/billing/customer" element={<CustomerListPage/>}/>
			<Route path="/app/admin/billing/customer/:id"
				   element={<CustomerEditPage/>}/>
			<Route path="/app/admin/billing/customer/new"
				   element={<CustomerEditPage/>}/>
			<Route path="/app/admin/billing/occupation" element={<OccupationPage/>}/>
			<Route path="/app/admin/billing/wiki"
				   element={<WikiPageListPage section={SECTION_BILLING}/>}/>
			<Route path="/app/admin/billing/wiki/:id"
				   element={<WikiPageEditPage section={SECTION_BILLING}/>}/>
			<Route path="/app/admin/billing/wiki/new"
				   element={<WikiPageEditPage section={SECTION_BILLING}/>}/>
			<Route path="/app/admin/billing/import"
				   element={<RedmineImportPage/>}/>
			<Route path="/app/admin/billing/dedication-batch"
				   element={<DedicationBatchPage/>}/>
		</Route>
	);
}

export default AdminBillingRoutes;


export const AdminBillingMenu = () => {
	return (
		<>
			<SideBarItem
				href={"/app/admin/billing/overview"}
				label={"Panel general"}
				icon={<Dashboard/>}
			/>
			<SideBarItem
				href={"/app/admin/billing/occupation"}
				label={"Ocupación"}
				icon={<GridOn/>}
			/>
			<SideBarItem
				href={"/app/admin/billing/bill"}
				label={"Facturas"}
				icon={<Receipt/>}
			/>
			<SideBarItem
				href={"/app/admin/billing/customer"}
				label={"Clientes"}
				icon={<People/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/budget"}
				label={"Presupuestos"}
				icon={<Euro/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/support-sla"}
				label={"Plazos de respuesta"}
				icon={<Timer/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/discount"}
				label={"Descuentos"}
				icon={<Savings/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/sepa-mandate"}
				label={"Mandatos SEPA"}
				icon={<AccountBalance/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/sepa-remittance"}
				label={"Remesas SEPA"}
				icon={<East/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/wiki"}
				label={"Wiki"}
				icon={<NoteAlt/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/import"}
				label={"Importar redmine."}
				icon={<ImportExport/>}
			/>

			<SideBarItem
				href={"/app/admin/billing/dedication-batch"}
				label={"Batch dedicaciones"}
				icon={<ImportExport/>}
			/>
		</>
	);
}